import React, { useEffect, useState } from "react";
import "./Stats.css";
import { FaRocket, FaDollarSign, FaUsers, FaChartLine, FaKey } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const statsData = [
  { icon: <FaRocket />, number: 900, label: "Applications Launched" },
  { icon: <FaDollarSign />, number: 50, suffix: "M", label: "Projected Annual Revenue" },
  { icon: <FaUsers />, number: 100700, label: "Active Users" },
  { icon: <FaChartLine />, number: 100000, label: "Monthly Website Traffic" },
  { icon: <FaKey />, number: 33000, label: "Licenses Sold" },
];

const Stats = () => {
  const [progress, setProgress] = useState(0);
  const duration = 2000; 

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          let start = 0;
          const stepTime = 16; 
          const increment = (stepTime / duration) * 100;

          const timer = setInterval(() => {
            start += increment;
            if (start >= 100) {
              setProgress(100);
              clearInterval(timer);
            } else {
              setProgress(start);
            }
          }, stepTime);
        }
      },
      { threshold: 0.5 }
    );

    const section = document.querySelector("#stats");
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" id="stats">
      <div className="stats-card">
        {statsData.map((stat, index) => {
          const value = Math.floor((progress / 100) * stat.number);
          return (
            <React.Fragment key={index}>
              <div
                className="stat-row"
                data-aos="zoom-in-up"
                data-aos-delay={index * 150} 
              >
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-text">
                  <h3 className="stat-number">
                    {value.toLocaleString()}
                    {stat.suffix || ""}
                  </h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </div>
              {index < statsData.length - 1 && <div className="stat-divider"></div>}
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
};

export default Stats;
